import _styledstyled_components from 'styled-components';
            const _styled = typeof _styledstyled_components.default === 'undefined' ? _styledstyled_components : _styledstyled_components.default;;
import { CloseIcon } from './Icons';
export const CloseButton = ({
  visible = true,
  children,
  ...props
}) => {
  return <_StyledDiv {...props} $_css={[{
    "position": "absolute",
    "top": "1.25rem",
    "right": "0.5rem",
    "zIndex": "50",
    "cursor": "pointer",
    "padding": "0.5rem",
    "fontSize": "16px",
    "--tw-text-opacity": "1",
    "color": "rgb(255 255 255 / var(--tw-text-opacity))",
    "opacity": "1",
    "transitionProperty": "opacity",
    "transitionTimingFunction": "cubic-bezier(0, 0, 0.2, 1)",
    "transitionDuration": "150ms",
    "transitionDelay": "200ms",
    ":hover": {
      "opacity": "1"
    },
    "@media (min-width: 640px)": {
      "right": "0.75rem",
      "padding": "0.625rem",
      "fontSize": "20px",
      "opacity": "0.9"
    },
    "@media (min-width: 768px)": {
      "right": "1rem",
      "opacity": "0.75"
    },
    "@media (min-width: 1024px)": {
      "right": "1.25rem"
    }
  }, !visible && {
    "opacity": "0"
  }]}>
      {children ?? <CloseIcon />}
    </_StyledDiv>;
};
var _StyledDiv = _styled("div").withConfig({
  componentId: "sc-16guxl7-0"
})(["", ""], p => p.$_css);